import React, { Component } from 'react';
import { Button, Container, Image } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class MobileDesktopHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeItem: 'home'
        }
    }

    handleItemClick = (e, { name }) => this.setState({ activeItem: name })

    handleMenuOpen = () => {
        let state = !this.state.menuOpen
        this.setState({ menuOpen:  state})
        this.props.menuOpen(state)
    }

    render() {
        const { activeItem, menuOpen } = this.state;
        return (
            <div>
                <Container className="mpost-header--home--menu mobile">
                    <Image centered className="mpost-header--logo--light" src={require('../assets/img/logo-light.svg')} size="mini" />
                    <Button className="mpost-mobile-button--menu" basic inverted icon="sidebar" onClick={this.props.menuOpen} />
                </Container>
            </div>
        )
    }
}


MobileDesktopHeader.propTypes = {
    menuOpen: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/HomeMobileHeader.js